import { _ } from "../../core/polyglot/polyglot.js";
import {
	formatAsFullYearMonthAndDay,
	formatAsShortDate,
} from "../../core/helpers/date-formatting-util.js";
import Period from "./Period.js";

/**
 * `CustomPeriod` is a period representing a custom timespan within a fiscal year.
 *
 * @param {string} [spec.label] - When provided, use the label as display
 * string in `toSmartString`.
 */
export default class CustomPeriod extends Period {
	constructor(spec) {
		super(spec);
		this._name = _("Custom");
		this._label = spec.label;
	}

	isCustomPeriod() {
		return true;
	}

	toString() {
		return `${this.getPeriodType()}-${formatAsFullYearMonthAndDay(
			this._start,
		)}-${formatAsFullYearMonthAndDay(this._end)}`;
	}

	toSmartString() {
		if (this._label) {
			return this._label;
		}
		return `${formatAsShortDate(
			this.getStartDateString(),
		)} - ${formatAsShortDate(this.getEndDateString())}`;
	}

	equals(candidate) {
		if (!candidate) {
			return false;
		}
		if (!candidate.getYear() && this._year) {
			return false;
		}

		return (
			candidate.isStartingAt(this._start) &&
			candidate.isEndingAt(this._end)
		);
	}

	static getType() {
		return "Custom";
	}
}
